// Online store, phase 3 (flag `store`): discount codes, the sales report and the low-stock list.
export const promosEn = {
  'promos.subtitle': 'Codes shoppers type in the cart. The shop checks every code itself; each one has a total cap and a cap per customer.',
  'promos.new': 'New code',
  'promos.edit': 'Edit {code}',
  'promos.saved': 'Discount code saved',
  'promos.delete': 'Delete',
  'promos.deleteConfirm': 'Delete code {code}? Orders that used it keep their discount.',
  'promos.deleted': 'Discount code deleted',
  'promos.full': 'A shop can have at most {n} discount codes. Delete one to add another.',
  'promos.empty.title': 'No discount codes yet',
  'promos.empty.body': 'Add a code, e.g. HEMAT10 for 10% off, and shoppers can use it in the cart.',
  'promos.col.code': 'Code',
  'promos.col.offer': 'Discount',
  'promos.col.dates': 'Valid',
  'promos.col.used': 'Used',
  'promos.col.status': 'Status',
  'promos.always': 'No end date',
  'promos.hinted': 'Suggested in the cart',
  'promos.perCustomer': 'max. {n} per customer',
  'promos.state.active': 'Active',
  'promos.state.scheduled': 'Scheduled',
  'promos.state.ended': 'Ended',
  'promos.state.used_up': 'Used up',
  'promos.state.off': 'Off',
  'promos.kind.percent': 'Percent off',
  'promos.kind.fixed': 'Rupiah off',
  'promos.kind.free_shipping': 'Free shipping',
  'promos.offer.percent': '{n}% off',
  'promos.offer.fixed': '{amount} off',
  'promos.offer.free_shipping': 'Free shipping',
  'promos.offer.min': 'min. {amount}',
  'promos.field.code': 'Code',
  'promos.field.codeHint': '3 to 20 letters and digits. Shoppers can type it in any case.',
  'promos.field.kind': 'Type',
  'promos.field.percent': 'Percent',
  'promos.field.percentHint': '1 to {max}.',
  'promos.field.amount': 'Amount off (Rp)',
  'promos.field.amountHint': 'Whole rupiah. Never more than the cart itself.',
  'promos.field.minOrder': 'Minimum order (Rp)',
  'promos.field.minOrderHint': 'The cart subtotal before the discount. Empty: any amount.',
  'promos.field.startsOn': 'From',
  'promos.field.startsOnHint': 'Jakarta time. Empty: from today.',
  'promos.field.endsOn': 'Until (included)',
  'promos.field.endsOnHint': 'Jakarta time. Empty: no end date.',
  'promos.field.usageLimit': 'Total uses',
  'promos.field.usageLimitHint': 'Empty: {n}. At most {max}.',
  'promos.field.perCustomer': 'Uses per customer',
  'promos.field.perCustomerHint': 'Counted by email. Empty: {n}. At most {max}.',
  'promos.field.active': 'Active',
  'promos.field.activeHint': 'Off: the shop treats the code as unknown.',
  'promos.field.showHint': 'Suggest it in the cart',
  'promos.field.showHintHint': 'Shoppers see it as a suggestion under the code field while the code is valid.',
  'promos.field.note': 'Note for the team',
  'promos.field.noteHint': 'Optional, not shown in the shop.',
  'promos.footnote': 'A use counts from the moment the order is placed. An order that expires unpaid or is cancelled gives its use back.',
  'reports.subtitle': 'Orders and revenue of the online store. Revenue counts paid orders only; days are Jakarta time.',
  'reports.range': 'Period',
  'reports.lastDays': 'Last {n} days',
  'reports.rangeNote': '{from} to {to}',
  'reports.revenue': 'Revenue',
  'reports.revenueNote': 'Paid orders, shipping included',
  'reports.discountNote': 'After {amount} in discount codes',
  'reports.paidOrders': 'Paid orders',
  'reports.ofOrders': 'of {n} orders placed',
  'reports.average': 'Average order',
  'reports.averageNote': 'Revenue ÷ paid orders',
  'reports.paidRate': 'Paid rate',
  'reports.paidRateNote': 'Paid vs. left to expire ({expired} expired)',
  'reports.chart.title': 'Revenue per day',
  'reports.chart.label': 'Bar chart of paid revenue per day',
  'reports.chart.hint': 'Point at a day to see its numbers',
  'reports.chart.orders': '{paid} paid of {all} orders',
  'reports.chart.table': 'Show as a table',
  'reports.col.day': 'Day',
  'reports.col.orders': 'Orders',
  'reports.col.paid': 'Paid',
  'reports.col.revenue': 'Revenue',
  'reports.byStatus': 'Orders by status',
  'reports.top': 'Top products',
  'reports.topEmpty': 'No paid orders in this period yet.',
  'reports.pieces': '{n} pcs',
  'reports.footnote': 'Paid means paid, packed, shipped or delivered. Product revenue is before discount codes and shipping.',
  'lowStock.subtitle': 'Variants at or under their own low-stock alert, emptiest first. Set the alert per colour and size in the product editor.',
  'lowStock.more': 'Showing the {shown} emptiest of {total}.',
  'lowStock.empty.title': 'Nothing is low on stock',
  'lowStock.empty.body': 'Variants appear here when their stock reaches their low-stock alert.',
  'lowStock.col.product': 'Product',
  'lowStock.col.variant': 'Colour · size',
  'lowStock.col.stock': 'Stock',
  'lowStock.col.mark': 'Alert at',
  'lowStock.soldOut': 'Sold out',
  'lowStock.left': '{n} left',
  'lowStock.edit': 'Edit stock',
  'dashboard.store.title': 'Store, last 30 days',
  'dashboard.store.revenue': 'Revenue',
  'dashboard.store.paid': 'Paid orders',
  'dashboard.store.lowStock': 'Low on stock',
  'dashboard.store.report': 'Open the sales report',
  'dashboard.entity.promo': 'discount code',
}

export const promosId: Record<keyof typeof promosEn, string> = {
  'promos.subtitle': 'Kode yang diketik pembeli di keranjang. Toko mengecek sendiri setiap kode; tiap kode punya batas total dan batas per pelanggan.',
  'promos.new': 'Kode baru',
  'promos.edit': 'Ubah {code}',
  'promos.saved': 'Kode promo disimpan',
  'promos.delete': 'Hapus',
  'promos.deleteConfirm': 'Hapus kode {code}? Pesanan yang sudah memakainya tetap dapat diskon.',
  'promos.deleted': 'Kode promo dihapus',
  'promos.full': 'Satu toko bisa punya paling banyak {n} kode promo. Hapus satu dulu untuk menambah.',
  'promos.empty.title': 'Belum ada kode promo',
  'promos.empty.body': 'Tambah kode, misalnya HEMAT10 untuk diskon 10%, lalu pembeli bisa memakainya di keranjang.',
  'promos.col.code': 'Kode',
  'promos.col.offer': 'Diskon',
  'promos.col.dates': 'Berlaku',
  'promos.col.used': 'Terpakai',
  'promos.col.status': 'Status',
  'promos.always': 'Tanpa tanggal akhir',
  'promos.hinted': 'Disarankan di keranjang',
  'promos.perCustomer': 'maks. {n} per pelanggan',
  'promos.state.active': 'Aktif',
  'promos.state.scheduled': 'Terjadwal',
  'promos.state.ended': 'Berakhir',
  'promos.state.used_up': 'Kuota habis',
  'promos.state.off': 'Nonaktif',
  'promos.kind.percent': 'Diskon persen',
  'promos.kind.fixed': 'Potongan rupiah',
  'promos.kind.free_shipping': 'Gratis ongkir',
  'promos.offer.percent': 'Diskon {n}%',
  'promos.offer.fixed': 'Potongan {amount}',
  'promos.offer.free_shipping': 'Gratis ongkir',
  'promos.offer.min': 'min. {amount}',
  'promos.field.code': 'Kode',
  'promos.field.codeHint': '3 sampai 20 huruf dan angka. Pembeli boleh mengetik huruf besar atau kecil.',
  'promos.field.kind': 'Jenis',
  'promos.field.percent': 'Persen',
  'promos.field.percentHint': '1 sampai {max}.',
  'promos.field.amount': 'Potongan (Rp)',
  'promos.field.amountHint': 'Rupiah bulat. Tidak pernah lebih dari isi keranjang.',
  'promos.field.minOrder': 'Minimal belanja (Rp)',
  'promos.field.minOrderHint': 'Subtotal keranjang sebelum diskon. Kosong: berapa pun.',
  'promos.field.startsOn': 'Mulai',
  'promos.field.startsOnHint': 'Waktu Jakarta. Kosong: mulai hari ini.',
  'promos.field.endsOn': 'Sampai (termasuk)',
  'promos.field.endsOnHint': 'Waktu Jakarta. Kosong: tanpa tanggal akhir.',
  'promos.field.usageLimit': 'Total pemakaian',
  'promos.field.usageLimitHint': 'Kosong: {n}. Paling banyak {max}.',
  'promos.field.perCustomer': 'Pemakaian per pelanggan',
  'promos.field.perCustomerHint': 'Dihitung per email. Kosong: {n}. Paling banyak {max}.',
  'promos.field.active': 'Aktif',
  'promos.field.activeHint': 'Kalau mati, toko menganggap kode ini tidak ada.',
  'promos.field.showHint': 'Sarankan di keranjang',
  'promos.field.showHintHint': 'Pembeli melihatnya sebagai saran di bawah kolom kode selama kode masih berlaku.',
  'promos.field.note': 'Catatan untuk tim',
  'promos.field.noteHint': 'Opsional, tidak tampil di toko.',
  'promos.footnote': 'Pemakaian dihitung sejak pesanan dibuat. Pesanan yang kedaluwarsa belum dibayar atau dibatalkan mengembalikan kuotanya.',
  'reports.subtitle': 'Pesanan dan pendapatan toko online. Pendapatan hanya dari pesanan yang sudah dibayar; hari pakai waktu Jakarta.',
  'reports.range': 'Periode',
  'reports.lastDays': '{n} hari terakhir',
  'reports.rangeNote': '{from} sampai {to}',
  'reports.revenue': 'Pendapatan',
  'reports.revenueNote': 'Pesanan dibayar, termasuk ongkir',
  'reports.discountNote': 'Setelah diskon kode promo {amount}',
  'reports.paidOrders': 'Pesanan dibayar',
  'reports.ofOrders': 'dari {n} pesanan masuk',
  'reports.average': 'Rata-rata pesanan',
  'reports.averageNote': 'Pendapatan ÷ pesanan dibayar',
  'reports.paidRate': 'Tingkat bayar',
  'reports.paidRateNote': 'Dibayar vs. dibiarkan kedaluwarsa ({expired} kedaluwarsa)',
  'reports.chart.title': 'Pendapatan per hari',
  'reports.chart.label': 'Grafik batang pendapatan per hari dari pesanan dibayar',
  'reports.chart.hint': 'Arahkan ke satu hari untuk lihat angkanya',
  'reports.chart.orders': '{paid} dibayar dari {all} pesanan',
  'reports.chart.table': 'Lihat sebagai tabel',
  'reports.col.day': 'Hari',
  'reports.col.orders': 'Pesanan',
  'reports.col.paid': 'Dibayar',
  'reports.col.revenue': 'Pendapatan',
  'reports.byStatus': 'Pesanan per status',
  'reports.top': 'Produk terlaris',
  'reports.topEmpty': 'Belum ada pesanan dibayar di periode ini.',
  'reports.pieces': '{n} pcs',
  'reports.footnote': 'Dibayar artinya dibayar, dikemas, dikirim, atau diterima. Pendapatan produk dihitung sebelum kode promo dan ongkir.',
  'lowStock.subtitle': 'Varian yang stoknya sudah sampai batas peringatannya, dari yang paling kosong. Atur batasnya per warna dan ukuran di editor produk.',
  'lowStock.more': 'Menampilkan {shown} yang paling kosong dari {total}.',
  'lowStock.empty.title': 'Tidak ada stok yang menipis',
  'lowStock.empty.body': 'Varian muncul di sini kalau stoknya sampai batas peringatan.',
  'lowStock.col.product': 'Produk',
  'lowStock.col.variant': 'Warna · ukuran',
  'lowStock.col.stock': 'Stok',
  'lowStock.col.mark': 'Peringatan di',
  'lowStock.soldOut': 'Habis',
  'lowStock.left': 'Sisa {n}',
  'lowStock.edit': 'Ubah stok',
  'dashboard.store.title': 'Toko, 30 hari terakhir',
  'dashboard.store.revenue': 'Pendapatan',
  'dashboard.store.paid': 'Pesanan dibayar',
  'dashboard.store.lowStock': 'Stok menipis',
  'dashboard.store.report': 'Buka laporan penjualan',
  'dashboard.entity.promo': 'kode promo',
}
